export default __webpack_public_path__ + "static/media/b.0d4f125e.jpg";